import React, { useEffect, useState } from 'react';
import DashboardHeaderItem from '../../../components/dashboardheader';
import TotalProduction from '../../../assets/images/TotalProductionDisactive.svg';
import TotalInstalled from '../../../assets/images/TotalInstalled.svg';
import TotalAlert from '../../../assets/images/TotalAlert.svg';
import TotalProductionActive from '../../../assets/images/TotalProduction.svg';
import TotalInstalledActive from '../../../assets/images/TotalInstalledActive.svg';
import TotalAlertActive from '../../../assets/images/TotalAlertActive.svg';

import ManufactureUnit from './manufactureUnit';
import RegisterUnit from './registeredUnit';
import UnRegisterUnit from './unRegisteredUnit';
import { useHook as InventoryUseHook } from './useHook';

const Inventory = () => {
  const [pageName, setPageName] = useState('manufactured');
  const {
    fetchRisteredInventory,
    fetchManufacturedInventory,
    fetchUnRisteredInventory,
  } = InventoryUseHook();
  const handlePageRouteChange = (title: string) => {
    setPageName(title);
  };
  const [manufacturedTotalNo, setManufacturedTotalNo] = useState(0);
  const [registeredUnitsTotalNo, setRegisteredUnitsTotalNo] = useState(0);
  const [unRegisteredUnitsTotalNo, setUnRegisteredUnitsTotalNo] = useState(0);

  useEffect(() => {
    setManufacturedInventory();
    setRegisterInventory();
    setUnRegisterInventory();
  }, []);
  const setManufacturedInventory = async () => {
    await fetchManufacturedInventory({}).then((res: any) => {
      setManufacturedTotalNo(res?.count || 0);
    });
  };
  const setRegisterInventory = async () => {
    await fetchRisteredInventory({}).then((res: any) => {
      setRegisteredUnitsTotalNo(res?.count || 0);
    });
  };
  const setUnRegisterInventory = async () => {
    await fetchUnRisteredInventory({}).then((res: any) => {
      setUnRegisteredUnitsTotalNo(res?.count || 0);
    });
  };
  return (
    <>
      <header className="dashboard_topheader">
        <DashboardHeaderItem
          iconSrc={
            pageName === 'manufactured'
              ? TotalProductionActive
              : TotalProduction
          }
          title="Manufactured Units"
          value={manufacturedTotalNo}
          id="manufactured"
          action={handlePageRouteChange}
          activeClass={pageName === 'manufactured' ? true : false}
        />
        <DashboardHeaderItem
          iconSrc={
            pageName === 'unregistered' ? TotalInstalledActive : TotalInstalled
          }
          title="Unregistered Units"
          value={unRegisteredUnitsTotalNo}
          id="unregistered"
          action={handlePageRouteChange}
          activeClass={pageName === 'unregistered' ? true : false}
        />
        <DashboardHeaderItem
          iconSrc={pageName === 'registered' ? TotalAlertActive : TotalAlert}
          title="Registered Units"
          value={registeredUnitsTotalNo}
          id="registered"
          action={handlePageRouteChange}
          activeClass={pageName === 'registered' ? true : false}
        />
      </header>

      {pageName === 'manufactured' ? (
        <ManufactureUnit setTotal={setManufacturedInventory} />
      ) : pageName === 'unregistered' ? (
        <UnRegisterUnit />
      ) : pageName === 'registered' ? (
        <RegisterUnit />
      ) : (
        <></>
      )}
    </>
  );
};

export default Inventory;
